import { colors } from '@fhs/ui/src/tokens/colors';

/**
 * Colours for the map markers, following the map assets in the NOP master design file.
 *
 * The greys and the user-location blue are deliberately not `@fhs/ui` tokens: they are tuned
 * against map tiles rather than app surfaces and have no equivalent in the token table.
 *
 * Kept in a module of its own, reading the token table directly rather than through the
 * `@fhs/ui` barrel, so the legacy web map in `workspaces/frontend/src/hooks/use-map` can share
 * the palette without pulling the component library along with it.
 */
export const markerColors = {
  open: colors.$houseRed,
  closed: '#838383',
  selectedOpen: colors.$houseRed,
  selectedClosed: colors.$houseDark,
  userLocation: '#007AFF',
  surface: colors.$white,
} as const;
